export default "__VITE_ASSET__00d12532__"